import Header from "@/reusable_sections/Header";
import PageHero from "@/components/PageHero";
import ServiceIntro from "@/components/service/ServiceIntro";
import ServiceCards from "@/components/service/ServiceCards";
import TarmacQuote from "./sections/TarmacQuote";
import OtherServices from "@/components/service/OtherServices";
import CtaBand from "@/components/CtaBand";
import Footer from "@/reusable_sections/Footer";
import { Car, Search, Wrench, RefreshCw, Settings2, ShieldCheck } from "lucide-react";
const subServices = [{
  title: "Residential Driveway Installation",
  description: "Transform your home's kerb appeal with high-quality, durable tarmac driveways tailored to your style. Complete with custom design, excavation, sub-base preparation, and precision machine laying.",
  icon: Car
}, {
  title: "Commercial Tarmac Surfacing",
  description: "Heavy-duty surfacing solutions for car parks, access roads, and commercial estates across Southampton, Hampshire & surrounding areas. Large-scale paving, line marking, and full safety compliance.",
  icon: Search
}, {
  title: "Pothole Repair & Maintenance",
  description: "Rapid-response repair services to prevent further damage and ensure safe vehicle transit. Efficient patching, filling, crack-sealing technology, and preventative maintenance.",
  icon: Wrench
}, {
  title: "Tarmac Resurfacing",
  description: "Give your existing surface a new lease of life with our professional overlay and restoration techniques. Surface cleaning, bond coat application, and a fresh wearing course layer.",
  icon: RefreshCw
}, {
  title: "Decorative Tarmac Options",
  description: "Enhance your property with red or green coloured tarmac, stone mastic asphalt, or integrated block paving borders for an elegant, premium finish.",
  icon: Settings2
}, {
  title: "All-Weather Surface Solutions",
  description: "Specialised porous tarmac installations designed for optimal drainage, SuDS compliance, anti-slip textures, and year-round weather-resistant durability.",
  icon: ShieldCheck
}];
export default function TarmacServicesPage() {
  return <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Header />

      <PageHero breadcrumbLabel="Tarmac Services" breadcrumbParent={{
      label: "Services",
      to: "/ServicesHubPage"
    }} eyebrow="OUR SERVICES" title="Tarmac Driveways in Southampton" intro="Professional tarmac and surface solutions across Southampton, Hampshire & surrounding areas. Smooth, durable, and all-weather finishes engineered to enhance property value and kerb appeal." imageSrc="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/premium_tarmac_driveway_installation.png" imageAlt="High-quality tarmac driveway installation in Southampton showing smooth black finish by Firststop Roofing Ltd" actions={true} />

      <ServiceIntro eyebrow="PREMIUM SURFACING" heading="Professional Tarmac & Surface Solutions" paragraphs={["From residential driveways to commercial parking areas, our tarmac solutions provide a smooth, durable, and all-weather finish that enhances property value and kerb appeal across Southampton, Hampshire & surrounding areas.", "Every driveway and surfacing installation is completed by Matt and our experienced team of roofing and property specialists in Southampton, with meticulous ground excavation, compacted sub-bases, precision edge restraints, and machine-laid wearing courses for long-lasting performance."]} benefits={["Superior durability engineered to withstand heavy vehicle traffic without cracking", "Rapid installation process minimising disruption to your home or business", "Low-maintenance, weed-resistant finish with excellent long-term reliability"]} imageSrc="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/premium_tarmac_driveway_installation.png" imageAlt="Professional tarmac driveway installation in Southampton by Firststop Roofing Ltd" cta={true} />

      <ServiceCards eyebrow="OUR TARMAC SERVICES" heading="Expert Surfacing & Driveway Solutions" intro="Comprehensive surfacing solutions for residential and commercial projects tailored to protect and enhance your property in Southampton, Hampshire & surrounding areas." items={subServices} columns={3} />

      <TarmacQuote />

      <OtherServices currentKey="tarmac" />

      <CtaBand />

      <Footer />
    </div>;
}